function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter } from "tslib";
import logdown from 'logdown';
import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';
import { Observable } from 'rxjs';
import RoundRobin from './RoundRobin';
import { cancelable } from './promise';
import { Code } from './proto';
import { GrpcStatus } from './types';
var logger = logdown('grpc', {
  prefixColor: '#0099ff'
});
var appInfo;
export var setAppInfo = function setAppInfo(info) {
  appInfo = info;
};

var getTransport = function getTransport(host, rpcOptions) {
  return new GrpcWebFetchTransport(Object.assign(Object.assign({}, rpcOptions), {
    baseUrl: host
  }));
};

export var setTransport = function setTransport(transport) {
  getTransport = transport;
};

var logRequest = function logRequest(servicePrefix) {
  if (!logger.state.isEnabled) {
    return;
  }

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (servicePrefix) {
    logger.log.apply(logger, [servicePrefix].concat(args));
  } else {
    logger.log.apply(logger, args);
  }
};

var createLogHandler = function createLogHandler(servicePrefix, log) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    logRequest.apply(void 0, [servicePrefix, log].concat(args));
  };
};

var setAuthHeaders = function setAuthHeaders(metadata, tokenProvider) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var authToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!tokenProvider) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return tokenProvider.getFreshToken();

          case 3:
            authToken = _context.sent;
            metadata['x-user-id'] = tokenProvider.getPersonId() || '';
            metadata.authorization = authToken;

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var setSharding = function setSharding(metadata, tsn, tokenProvider) {
  if (tsn) {
    metadata['x-shard'] = tsn;
    metadata['x-tsn'] = tsn;
  } else if (tokenProvider) {
    metadata['x-shard'] = tokenProvider.getPersonId() || '';
  }
};

var setAppHeaders = function setAppHeaders(metadata) {
  if (appInfo) {
    metadata['x-app-platform'] = 'web';
    metadata['x-app-product'] = appInfo.product;
    metadata['x-app-version'] = appInfo.version;
  }
};

var getHosts = function getHosts(_ref, tsn) {
  var hosts = _ref.hosts,
      accountHosts = _ref.accountHosts;
  return tsn && accountHosts && accountHosts[tsn] || hosts;
};

var getGrpcStatus = function getGrpcStatus(err) {
  var status = new GrpcStatus();

  if ('code' in err) {
    status.code = typeof err.code === 'string' ? Code[err.code] : err.code;
  }

  if ('message' in err) {
    status.message = decodeURIComponent(err.message);
  } else if (err.detail) {
    status.message = err.detail;
  }

  if ('meta' in err) {
    var details = err.meta['x-grpc-details'];
    var detailsArray = Array.isArray(details) ? details : [details];
    var statusDetails = [];
    detailsArray.forEach(function (item) {
      if (!item) {
        return;
      }

      var decodedDetails = decodeURIComponent(item);

      try {
        statusDetails.push(JSON.parse(decodedDetails));
      } catch (_a) {
        statusDetails.push(decodedDetails);
      }
    });
    status.details = statusDetails.length > 1 ? statusDetails : statusDetails[0];
  }

  return status;
};

var isRetryDisabled = function isRetryDisabled(retry, retryAttempt) {
  return retry === false || typeof retry === 'object' && (retry.disabled || retry.maxAttempts != null && retry.maxAttempts >= 0 && retryAttempt >= retry.maxAttempts);
};

var _stream = function stream(params, options) {
  var roundRobin = new RoundRobin(typeof params.retry === 'object' ? {
    minDelay: params.retry.minDelay,
    maxDelay: params.retry.maxDelay
  } : {});
  var hostIndex = 0;
  var retryAttempt = 0;

  var subscribe = function subscribe(streamParams, requestOptions, subscriber, onCancel) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var metadata, tokenProvider, handler, accountId, tsnParam, log, keepAlive, retryParams, timeout, meta, tsn, hosts, requestHandled, abortController, retry, handleEnd, handleError, host, transport, _handler, responses, statusPromise, status;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              metadata = requestOptions.metadata, tokenProvider = requestOptions.tokenProvider;
              handler = streamParams.handler, accountId = streamParams.accountId, tsnParam = streamParams.tsn, log = streamParams.log, keepAlive = streamParams.keepAlive, retryParams = streamParams.retry, timeout = streamParams.timeout;
              meta = Object.assign({}, metadata);
              setAppHeaders(meta);
              _context2.prev = 4;
              _context2.next = 7;
              return setAuthHeaders(meta, tokenProvider);

            case 7:
              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](4);
              subscriber.error(_context2.t0);
              return _context2.abrupt("return");

            case 13:
              if (!subscriber.closed) {
                _context2.next = 16;
                break;
              }

              logRequest(log, 'STREAM_IS_CLOSED');
              return _context2.abrupt("return");

            case 16:
              tsn = tsnParam !== null && tsnParam !== void 0 ? tsnParam : accountId === null || accountId === void 0 ? void 0 : accountId.tradeSystemName;
              hosts = getHosts(requestOptions, tsn);
              setSharding(meta, tsn, tokenProvider);
              requestHandled = false;
              abortController = new AbortController();
              roundRobin.startSuccessTimeout();

              retry = function retry(status) {
                if (subscriber.closed) {
                  logRequest(log, 'STREAM_IS_CLOSED');
                  return 0;
                }

                abortController.abort();
                var delay = roundRobin.retry(function () {
                  hostIndex = (hostIndex + 1) % hosts.length;
                  subscribe(streamParams, requestOptions, subscriber, onCancel);
                }, status);

                if (delay > 0) {
                  logRequest(log, 'STREAM_ROUND_ROBIN delay', delay);
                }

                return delay;
              };

              handleEnd = function handleEnd() {
                if (requestHandled) {
                  return;
                }

                requestHandled = true;
                logRequest(log, 'STREAM_END');

                if (keepAlive) {
                  logRequest(log, 'STREAM_KEEP_ALIVE');
                  retry();
                } else {
                  subscriber.complete();
                }
              };

              handleError = function handleError(err) {
                if (requestHandled) {
                  return;
                }

                requestHandled = true;
                var status = getGrpcStatus(err);
                logRequest(log, 'STREAM_ERROR', status);

                if (isRetryDisabled(retryParams, retryAttempt)) {
                  subscriber.error(status);
                } else {
                  retryAttempt += 1;
                  var delay = retry(status);

                  if (delay < 0) {
                    subscriber.error(status);
                  }
                }
              };

              try {
                host = hosts[hostIndex] || hosts[0];
                transport = getTransport(host, {
                  meta: meta,
                  timeout: timeout,
                  abort: abortController.signal
                });
                _handler = handler(transport, createLogHandler(log, 'STREAM_REQUEST')), responses = _handler.responses, statusPromise = _handler.status;
                responses.onMessage(function (data) {
                  subscriber.next(data);
                  roundRobin.reset();
                  retryAttempt = 0;
                  logRequest(log, 'STREAM_DATA', data);
                });
                responses.onError(function (err) {
                  handleError(err);
                });
                responses.onComplete(function () {
                  handleEnd();
                });
                statusPromise.then(function (status) {
                  logRequest(log, 'STREAM_STATUS', status);

                  if (Code[status.code] === Code.OK) {
                    handleEnd();
                  } else {
                    handleError(status);
                  }
                }, function (err) {
                  return handleError(err);
                });
              } catch (err) {
                status = getGrpcStatus(err);
                logRequest(log, 'STREAM_ERROR', status);
                subscriber.error(status);
              }

              onCancel(function () {
                if (requestHandled && !roundRobin.isActive) {
                  return;
                }

                logRequest(log, 'STREAM_CANCEL');
                requestHandled = true;
                abortController.abort();
                roundRobin.cancel();
              });

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 9]]);
    }));
  };

  return new Observable(function (subscriber) {
    var cancelRef;
    subscribe(params, options, subscriber, function (cancel) {
      cancelRef = cancel;
    });
    return function () {
      if (cancelRef) {
        cancelRef();
      }
    };
  });
};

var _unary = function unary(params, options) {
  var roundRobin = new RoundRobin(typeof params.retry === 'object' ? {
    minDelay: params.retry.minDelay,
    maxDelay: params.retry.maxDelay
  } : {});
  var abortController;
  var canceled = false;
  var rejectRetryPromise;
  var hostIndex = 0;
  var retryAttempt = 0;

  var cancelRetry = function cancelRetry() {
    roundRobin.cancel();
    rejectRetryPromise === null || rejectRetryPromise === void 0 ? void 0 : rejectRetryPromise(getGrpcStatus({
      code: Code.CANCELLED,
      message: 'Request canceled during retry',
      details: []
    }));
  };

  var request = function request(callParams, requestOptions) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var handler, accountId, tsnParam, log, retry, timeout, signal, metadata, tokenProvider, meta, tsn, hosts, onAbort, host, transport, _yield$handler, status, response, responseStatus, _status;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              handler = callParams.handler, accountId = callParams.accountId, tsnParam = callParams.tsn, log = callParams.log, retry = callParams.retry, timeout = callParams.timeout, signal = callParams.signal;
              metadata = requestOptions.metadata, tokenProvider = requestOptions.tokenProvider;
              meta = Object.assign({}, metadata);
              setAppHeaders(meta);
              _context3.next = 6;
              return setAuthHeaders(meta, tokenProvider);

            case 6:
              if (!(canceled || (signal === null || signal === void 0 ? void 0 : signal.aborted))) {
                _context3.next = 8;
                break;
              }

              throw getGrpcStatus({
                code: Code.CANCELLED,
                message: 'Request canceled before call',
                details: []
              });

            case 8:
              tsn = tsnParam !== null && tsnParam !== void 0 ? tsnParam : accountId === null || accountId === void 0 ? void 0 : accountId.tradeSystemName;
              hosts = getHosts(requestOptions, tsn);
              abortController = new AbortController();

              onAbort = function onAbort() {
                abortController === null || abortController === void 0 ? void 0 : abortController.abort();
              };

              if (signal) {
                signal.addEventListener('abort', onAbort, {
                  once: true
                });
              }

              setSharding(meta, tsn, tokenProvider);
              _context3.prev = 14;
              host = hosts[hostIndex] || hosts[0];
              transport = getTransport(host, {
                meta: meta,
                timeout: timeout,
                abort: abortController.signal
              });
              _context3.next = 19;
              return handler(transport, createLogHandler(log, 'UNARY_REQUEST'));

            case 19:
              _yield$handler = _context3.sent;
              status = _yield$handler.status;
              response = _yield$handler.response;

              if (signal) {
                signal.removeEventListener('abort', onAbort);
              }

              if (!(status && status.code && Code[status.code] > 0)) {
                _context3.next = 25;
                break;
              }

              throw status;

            case 25:
              responseStatus = response === null || response === void 0 ? void 0 : response.status;

              if (!((responseStatus === null || responseStatus === void 0 ? void 0 : responseStatus.code) && responseStatus.code > 0)) {
                _context3.next = 28;
                break;
              }

              throw responseStatus;

            case 28:
              logRequest(log, 'UNARY_DATA', response);
              return _context3.abrupt("return", response);

            case 32:
              _context3.prev = 32;
              _context3.t0 = _context3["catch"](14);

              if (signal) {
                signal.removeEventListener('abort', onAbort);
              }

              _status = getGrpcStatus(_context3.t0);
              logRequest(log, 'UNARY_ERROR', _status);

              if (!isRetryDisabled(retry, retryAttempt)) {
                _context3.next = 39;
                break;
              }

              throw _status;

            case 39:
              retryAttempt += 1;
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                rejectRetryPromise = undefined;
                var delay = roundRobin.retry(function () {
                  hostIndex = (hostIndex + 1) % hosts.length;
                  resolve(request(callParams, requestOptions));
                }, _status);

                if (delay < 0) {
                  reject(_status);
                } else {
                  logRequest(log, 'UNARY_ROUND_ROBIN delay', delay);
                  rejectRetryPromise = reject;
                }
              }));

            case 41:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[14, 32]]);
    }));
  };

  return cancelable(request(params, options), function () {
    logRequest(params.log, 'UNARY_CANCEL');
    canceled = true;
    abortController === null || abortController === void 0 ? void 0 : abortController.abort();
    cancelRetry();
  });
};

export var makeRequest = function makeRequest(options) {
  return {
    unary: function unary(unaryParams) {
      return _unary(unaryParams, options);
    },
    stream: function stream(streamParams) {
      return _stream(streamParams, options);
    }
  };
};